function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data,
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get("quantity-selector")) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".qty");
      this.step = this.input.getAttribute("step");
      this.changeEvent = new Event("change", {
        bubbles: true,
      });
      // Create buttons
      this.subtract = this.querySelector(".minus");
      this.add = this.querySelector(".plus");

      // Add functionality to buttons
      this.subtract.addEventListener("click", () =>
        this.change_quantity(-1 * this.step)
      );
      this.add.addEventListener("click", () =>
        this.change_quantity(1 * this.step)
      );
    }
    connectedCallback() {
      this.classList.add("buttons_added");
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute("min") > quantity + change) {
        return;
      }
      if (this.input.getAttribute("max")) {
        if (this.input.getAttribute("max") < quantity + change) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle("disabled", value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle("disabled", value >= max);
      }
    }
  }
  customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains("active")) {
      submenu.classList.add("active");
    } else {
      submenu.classList.remove("active");
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector(".product-card-swatches");
      this.image = this.querySelector(
        ".product-featured-image-link .product-primary-image"
      );
      this.additional_images = this.querySelectorAll(
        ".product-secondary-image"
      );
      this.additional_images_nav = this.querySelectorAll(
        ".product-secondary-images-nav li"
      );
      this.quick_add = this.querySelector(
        ".product-card--add-to-cart-button-simple"
      );
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector(".product-featured-image");
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains("hover")) {
            image.classList.remove("hover");
            if (nav.length) {
              nav[index].classList.remove("active");
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains("hover")) {
            selimg.classList.add("hover");
            if (nav.length) {
              nav[sel].classList.add("active");
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove("hover");
          if (nav.length) {
            nav[index].classList.remove("active");
          }
        });
      };
      if (image_container) {
        image_container.addEventListener("touchstart", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchmove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("touchend", mouseleave, {
          passive: true,
        });
        image_container.addEventListener("mouseenter", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mousemove", mousemove, {
          passive: true,
        });
        image_container.addEventListener("mouseleave", mouseleave, {
          passive: true,
        });
      }
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll(".product-card-swatch"),
        org_srcset = image ? image.dataset.srcset : "",
        active = swatches.querySelector(".product-card-swatch.active");

      swatch_list.forEach((swatch, index) => {
        swatch.addEventListener("mouseover", function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove("active");
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute("srcset", swatch.dataset.srcset);
            } else {
              image.setAttribute("srcset", org_srcset);
            }
          }

          swatch.classList.add("active");
        });
        swatch.addEventListener("click", function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add("loading");
      this.quick_add.setAttribute("aria-disabled", true);

      const config = {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/javascript",
        },
      };

      let formData = new FormData(this.form);

      formData.append("id", this.quick_add.dataset.productId);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append("sections_url", window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent("cart:item-added", {
            product: response.hasOwnProperty("items")
              ? response.items[0]
              : response,
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove("loading");
          this.quick_add.removeAttribute("aria-disabled");
        });

      return false;
    }
    getSectionsToRender() {
      return [
        {
          id: "Cart",
          section: "main-cart",
          selector: ".thb-cart-form",
        },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
        {
          id: "Cart-Drawer",
          section: "cart-drawer",
          selector: ".cart-drawer",
        },
      ];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (typeof CartDrawer !== "undefined") {
          new CartDrawer();
        }
        if (typeof Cart !== "undefined") {
          new Cart().renderContents(parsedState);
        }
      });

      const isBuildABoxPage =
        document.body.getAttribute("data-page") === "build-a-box";

      if (isBuildABoxPage != true) {
        if (document.getElementById("Cart-Drawer")) {
          document.getElementById("Cart-Drawer").classList.add("active");
          document.body.classList.add("open-cart");
          document.body.classList.add("open-cc");
          if (
            document
              .getElementById("Cart-Drawer")
              .querySelector(".product-recommendations--full")
          ) {
            document
              .getElementById("Cart-Drawer")
              .querySelector(".product-recommendations--full")
              .classList.add("active");
          }
          dispatchCustomEvent("cart-drawer:open");
        }
      }
    }
    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define("product-card", ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector(".header-section"),
      header_main = document.getElementById("header"),
      menu = document.getElementById("mobile-menu"),
      toggle = document.querySelector(".mobile-toggle-wrapper"),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener("keyup", (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === "ESCAPE") {
          toggle.removeAttribute("open");
          toggle.classList.remove("active");
        }
      }
    });
    toggle.querySelector(".mobile-toggle").addEventListener("click", (e) => {
      setAnnouncementHeight(header);
      if (toggle.classList.contains("active")) {
        e.preventDefault();
        document.body.classList.remove("overflow-hidden");
        document.body.classList.remove("white-header");
        toggle.classList.remove("active");
        this.closeAnimation(toggle);
      } else {
        document.body.classList.add("overflow-hidden");
        document.body.classList.add("white-header");
        setTimeout(() => {
          toggle.classList.add("active");
        });
      }
      window.dispatchEvent(new Event("resize.resize-select"));
    });

    // Mobile Menu offset
    window.addEventListener(
      "scroll",
      function () {
        setHeaderOffset(header);
        setHeaderHeight(header_main);
        // Sticky Header Class
        if (header_main.classList.contains("header-sticky--active")) {
          let offset =
            parseInt(header_main.getBoundingClientRect().top, 10) +
            document.documentElement.scrollTop;

          header_main.classList.toggle(
            "is-sticky",
            window.scrollY >= offset && window.scrollY > 0
          );
        }
      },
      {
        passive: true,
      }
    );
    window.dispatchEvent(new Event("scroll"));

    if (document.getElementById("shopify-section-announcement-bar")) {
      const a_bar = document.getElementById("shopify-section-announcement-bar");
      window.addEventListener(
        "resize",
        function () {
          setAnnouncementHeight(a_bar);
        },
        {
          passive: true,
        }
      );
      window.dispatchEvent(new Event("resize"));
    }
    // Buttons.
    menu
      .querySelectorAll("summary")
      .forEach((summary) =>
        summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
    menu
      .querySelectorAll("button")
      .forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty(
      "--announcement-height",
      h + "px"
    );
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty("--header-offset", h + "px");
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty("--header-height", h + "px");
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".link-container");
    const isOpen = detailsElement.hasAttribute("open");

    setTimeout(() => {
      detailsElement.classList.add("menu-opening");
      parentMenuElement && parentMenuElement.classList.add("submenu-open");
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        detailsElement.querySelectorAll("details").forEach((details) => {
          details.removeAttribute("open");
          details.classList.remove("menu-opening");
          details.classList.remove("submenu-open");
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100)
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu"
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
      let cc = document.querySelector(".click-capture");

      // Add functionality to buttons
      this.addEventListener("click", (e) => this.close_panel(e));
      document.addEventListener("panel:close", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener("click", (e) => {
        let panel = document.querySelectorAll(".side-panel.active");
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e.target.closest(".side-panel");

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains("product-drawer")) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains("cart-drawer")) {
        if (panel.querySelector(".product-recommendations--full")) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel
              .querySelector(".product-recommendations--full")
              .classList.remove("active");
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains("open-quick-view")) {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector(".product-recommendations--full")) {
            if (!document.body.classList.contains("open-quick-view")) {
              setTimeout(() => {
                panel.classList.remove("active");
                document.body.classList.remove("open-cc");
                document.body.classList.remove("open-cart");
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove("active");
            document.body.classList.remove("open-cc");
            document.body.classList.remove("open-cart");
          }
        }
      } else {
        panel.classList.remove("active");
        document.body.classList.remove("open-cc");
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById("Product-Drawer");

      if (panel.querySelector(".product-quick-images--container")) {
        panel
          .querySelector(".product-quick-images--container")
          .classList.remove("active");
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove("active");
        if (!document.body.classList.contains("open-cart")) {
          document.body.classList.remove("open-cc");
        }
        document.body.classList.remove("open-quick-view");
      } else {
        if (panel.querySelector(".product-quick-images--container")) {
          setTimeout(() => {
            panel.classList.remove("active");
            if (!document.body.classList.contains("open-cart")) {
              document.body.classList.remove("open-cc");
            }
            document.body.classList.remove("open-quick-view");
            panel.querySelector("#Product-Drawer-Content").innerHTML = "";
          }, 500);
        }
      }
    }
  }
  customElements.define("side-panel-close", PanelClose);

  document.addEventListener("keyup", (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === "ESCAPE") {
        dispatchCustomEvent("panel:close");
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    this.container = document.getElementById("Cart-Drawer");

    if (!this.container) {
      return;
    }

    let _this = this,
      button = document.getElementById("cart-drawer-toggle"),
      quantities = this.container.querySelectorAll(".quantity input");

    if (window.location.search.includes("show-cart=true")) {
      const newUrl = window.location.href.replace("?show-cart=true", "");
      history.replaceState(null, null, newUrl);
      this.openCartDrawer();
    }

    // Add functionality to buttons
    button.addEventListener("click", (e) => this.openCartDrawer(e));

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener(
      "change",
      this.debouncedOnChange.bind(this)
    );

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }

  openCartDrawer(e) {
    if (e) {
      e.preventDefault();
    }
    document.body.classList.add("open-cc");
    document.body.classList.add("open-cart");
    this.container.classList.add("active");
    this.container.focus();
    setTimeout(() => {
      if (this.container.querySelector(".product-recommendations--full")) {
        this.container
          .querySelector(".product-recommendations--full")
          .classList.add("active");
      }
    });
    dispatchCustomEvent("cart-drawer:open");
  }

  onChange(event) {
    if (event.target.classList.contains("qty")) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll(".remove");

    removes.forEach((remove) => {
      remove.addEventListener("click", (event) => {
        this.updateQuantity(event.target.dataset.index, "0");

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer",
      },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }
  updateSectionToRender() {
    const sections = [
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".side-panel-content",
      },
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer-buttons",
      },
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".steps-price",
      },
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".cart-drawer-shipping",
      },
      {
        id: "Cart-Drawer",
        section: "cart-drawer",
        selector: ".final-price-button",
      },
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".mini-cart-button",
      },
    ];

    return sections;
  }
  
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector("#CartDrawerTerms"),
      checkout_button = this.container.querySelector(".button.checkout");

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener("click", function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById("order-note-toggle");

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener("click", (event) => {
      notes_toggle.nextElementSibling.classList.add("active");
    });
    notes_toggle.nextElementSibling
      .querySelectorAll(".button, .order-note-toggle__content-overlay")
      .forEach((el) => {
        el.addEventListener("click", (event) => {
          notes_toggle.nextElementSibling.classList.remove("active");
          this.saveNotes();
        });
      });
  }
  saveNotes() {
    const data = {
      note: document.getElementById("mini-cart__notes").value.trim(),
    };
    const gift_message = document
      .getElementById("mini-cart__gift-message")
      .value.trim();
    if (gift_message.length > 0) {
      data.attributes = { gift_message: gift_message };
    }
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify(data),
    });
  }
  updateFreeShipping() {
    const free_shipping = this.container.querySelector(".free-shipping");

    if (free_shipping) {
      let amount_text = free_shipping.querySelector(
        ".free-shipping--text span"
      );
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(
        parseInt(free_shipping.dataset.minimum, 10) *
          (Shopify.currency.rate || 1)
      );
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format =
              window.theme.settings.money_with_currency_format ||
              "${{ amount }}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty("--percentage", percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.container
      .querySelector(`#CartDrawerItem-${line}`)
      .classList.add("thb-loading");
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    dispatchCustomEvent("line-item:change:start", {
      quantity: quantity,
    });
    if (this.container.querySelector(".product-recommendations--full")) {
      this.container
        .querySelector(".product-recommendations--full")
        .classList.remove("active");
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        dispatchCustomEvent("line-item:change:end", { // This is the item deleted event
          quantity: quantity,
          cart: parsedState,
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container
            .querySelector(`#CartDrawerItem-${line}`)
            .classList.remove("thb-loading");
        }
      });
  }
  updateCartContents() {
    const body = JSON.stringify({
      sections: this.updateSectionToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.updateSectionToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
      });
  }
  updateCartPlanPage() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      ...{
        body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.hide();
      }
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    this.querySelectorAll(".js-youtube").forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
    this.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    this.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-localization-forms")
      .forEach((localization) => {
        localization.addEventListener("change", (e) => {
          localization.querySelector("form").submit();
        });
      });
  }
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (
        e.target.matches(".resize-select") &&
        e.target.offsetParent !== null
      ) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener("resize.resize-select", function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement("option");
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement("select"),
      offset = 13;
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);
    if (
      sel.classList.contains("thb-language-code") ||
      sel.classList.contains("thb-currency-code") ||
      sel.classList.contains("facet-filters__sort")
    ) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== "undefined") {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document
      .querySelectorAll(".thb-widget-title.collapsible")
      .forEach((button) => {
        button.addEventListener("click", (e) => {
          button.classList.toggle("active");
        });
      });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector(".click-capture");
      this.drawer = document.getElementById("Product-Drawer");
      this.body = document.body;

      this.addEventListener("click", this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace("//", "/");
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains("loading")) {
        return;
      }
      this.classList.add("loading");
      fetch(href, {
        method: "GET",
      })
        .then((response) => {
          this.classList.remove("loading");
          return response.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#Product-Drawer-Content").innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML =
          sectionInnerHTML;

        let js_files = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");

        if (js_files.length > 0) {
          var head = document.getElementsByTagName("head")[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement("script");
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add("open-cc");
        this.body.classList.add("open-quick-view");
        this.drawer.classList.add("active");

        this.drawer.querySelector(".side-panel-close").focus();

        setTimeout(() => {
          this.drawer
            .querySelector(".product-quick-images--container")
            .classList.add("active");
        });
        dispatchCustomEvent("quick-view:open", {
          productUrl: href,
          productHandle: productHandle,
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get("side-panel-content-tabs")) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll("button");
      this.panels = this.parentElement.querySelectorAll(
        ".side-panel-content--tab-panel"
      );
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {}
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove("tab-active");
      });
      this.buttons[i].classList.add("tab-active");

      this.panels.forEach((panel) => {
        panel.classList.remove("tab-active");
      });
      this.panels[i].classList.add("tab-active");
    }
  }

  customElements.define("side-panel-content-tabs", SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector("details");
      this.summary = this.querySelector("summary");
      this.content = this.querySelector(".collapsible__content");
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined"
      ) {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector("summary").addEventListener("click", (e) =>
            this.onClick(e)
          );
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector("summary").offsetHeight,
        content_height = this.querySelector(
          ".collapsible__content"
        ).offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: "sine.inOut",
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = "hidden";
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = "";
        },
      });

      this.tl.fromTo(
        _this.details,
        {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: "height",
        },
        {
          duration: 0.6,
          height: final_height,
          clearProps: "height",
        }
      );

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
    }
  }
  customElements.define("collapsible-row", CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector(".thb-product-detail");

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem("recently-viewed");
    if (recentIds && typeof recentIds !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem(
      "recently-viewed",
      JSON.stringify(window.recentlyViewedIds)
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (typeof Localization !== "undefined") {
    new Localization();
  }
  if (typeof CartDrawer !== "undefined") {
    new CartDrawer();
  }
  if (typeof Header !== "undefined") {
    new Header();
  }
  if (typeof FooterMenuToggle !== "undefined") {
    new FooterMenuToggle();
  }
});

document.body.addEventListener("input", function (e) {
  if (e.target.closest(".cart-drawer__post-code")) {
    const inputPostCode = e.target;
    const h3Element = document.querySelector(".cart-drawer__postcode-value");
    const stepThreeElement = document.querySelector(
      ".delivery-postcode-step-three"
    );
    const fourStepTitle = document.querySelector(".four-step-code");
    h3Element.textContent = inputPostCode.value;
    stepThreeElement.textContent = inputPostCode.value;
    fourStepTitle.textContent = inputPostCode.value;
  }
});

async function addProductToCart(quantity = 1) {
  const productId = "12807484866602";
  let endpoint = "/cart/add.js";
  let formData = new FormData();

  formData.append("id", productId);
  formData.append("quantity", quantity);

  try {
    let response = await fetch(endpoint, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    let jsonResponse = await response.json();
    console.log("Product added successfully!", jsonResponse);
    return jsonResponse;
  } catch (error) {
    console.error("Error adding product:", error);
    throw error;
  }
}

// This is used for Morning Delivery i think
async function changeProductInCart(productId = "12807484866602", quantity = 0) {
  let endpoint = `/cart/change.js`;

  let formData = new FormData();
  formData.append("id", productId);
  formData.append("quantity", quantity);

  try {
    let response = await fetch(endpoint, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    let jsonResponse = await response.json();
    if (quantity === 0) {
      console.log("Product removed successfully!", jsonResponse);
    } else {
      console.log("Product quantity changed successfully!", jsonResponse);
    }
    return jsonResponse;
  } catch (error) {
    console.error("Error changing product in cart:", error);
    throw error;
  }
}

document.body.addEventListener("click", function (e) {
  const {
    dateField,
    deliveryMethodField,
    cartBody,
    stepsWrapper,
    stepOne,
    cartFooter,
    inputPostCode,
    stepTwo,
    postCodeMessage,
    stepThree,
    stepFour,
  } = {
    dateField: document.querySelector(".delivery-date"),
    deliveryMethodField: document.querySelector(".delivery-method"),
    cartBody: document.querySelector(".cart-body"),
    stepsWrapper: document.querySelector(".cart-drawer__steps"),
    stepOne: document.querySelector(".cart-drawer__step-one"),
    cartFooter: document.querySelector(".side-panel-footer"),
    inputPostCode: document.querySelector(".cart-drawer__post-code"),
    stepTwo: document.querySelector(".cart-drawer__step-two"),
    postCodeMessage: document.querySelector(".cart-drawer__postcode-error"),
    stepThree: document.querySelector(".cart-drawer__step-three"),
    stepFour: document.querySelector(".cart-drawer__step-four"),
  };

  const postCodePattern =
    /^(gir 0aa|[a-pr-uwyz][a-hk-y]?[0-9][0-9a-z]? ?[0-9][abd-hjlnp-uw-z]{2}|[a-pr-uwyz][a-hk-y]?[0-9a-z]? ?[0-9][abd-hjlnp-uw-z]{2}|[a-pr-uwyz][a-hk-y]?[0-9a-z]? ?[0-9][abd-hjlnp-uw-z][a-hk-y])$/i;

  if (e.target.closest(".cart-drawer__first-step-button")) {
    cartBody.classList.add("steps-active");
    stepsWrapper.classList.add("steps-active");
    stepOne.classList.add("step-one-active");
    cartFooter.classList.add("steps-active");
  } else if (e.target.closest(".steps-overlay")) {
    cartBody.classList.remove("steps-active");
    stepsWrapper.classList.remove("steps-active");
    cartFooter.classList.remove("steps-active");
  } else if (e.target.closest(".cart-drawer__step-two-back")) {
    stepOne.classList.add("step-one-active");
    stepOne.classList.remove("step-one-hide");
    stepTwo.classList.remove("step-two-active");
  } else if (e.target.closest(".cart-drawer__step-three-back")) {
    stepTwo.classList.add("step-two-active");
    const backButtonFour = document.querySelector(
      ".cart-drawer__fourth-step-button"
    );
    stepThree.classList.remove("step-three-active");
    backButtonFour.classList.remove("visible");
    changeProductInCart("12807484866602", 0);
  } else if (e.target.closest(".cart-drawer__step-four-back")) {
    stepThree.classList.add("step-three-active");
    stepFour.classList.remove("step-four-active");
  }
  if (e.target.closest(".cart-drawer__step-one-next")) {
    if (postCodePattern.test(inputPostCode.value)) {
      localStorage.setItem("postCode", inputPostCode.value);
      stepOne.classList.remove("step-one-active");
      stepOne.classList.add("step-one-hide");
      stepTwo.classList.add("step-two-active");
    } else {
      postCodeMessage.classList.add("active");
      e.preventDefault();
    }
  }
  if (e.target.closest(".add-fast-delivery")) {
    const deliveryMethodMorning = "Morning:";
    const fieldDate = document.getElementById("datepicker");
    fieldDate.value = deliveryMethodMorning;
    const h3Element = document.querySelector(".delivery-method-title");
    h3Element.textContent = "Morning";
    addProductToCart();
    stepThree.classList.add("step-three-active");
    stepTwo.classList.remove("step-two-active");
    const stepFourTitle = document.querySelector(".four-step-type");
    stepFourTitle.textContent = "Morning";
    initializePikaday(true);
  } else if (e.target.closest(".add-free-delivery")) {
    const deliveryMethodStandard = "Standard:";
    const fieldDate = document.getElementById("datepicker");
    fieldDate.value = deliveryMethodStandard;
    const h3Element = document.querySelector(".delivery-method-title");
    h3Element.textContent = "Standard";
    const stepFourTitle = document.querySelector(".four-step-type");
    stepFourTitle.textContent = "Standard";
    changeProductInCart("12807484866602", 0);
    stepTwo.classList.remove("step-two-active");
    stepThree.classList.add("step-three-active");
    initializePikaday(false);
  }
  if (e.target.closest(".cart-drawer__fourth-step-button")) {
    stepThree.classList.remove("step-three-active");
    stepFour.classList.add("step-four-active");
    const stepFourTitle = document.querySelector(".four-step-date");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  changeProductInCart("12807484866602", 0);
});

let pickerInstance;

function initializePikaday(isMorningDelivery = false) {
  if (pickerInstance) {
    pickerInstance.destroy();
  }

  const dateField = document.querySelector(".delivery-date");
  const productCartItems = document.querySelectorAll(".product-cart-item");
  const stepThree = document.querySelector(".cart-drawer__step-three");
  const stepFour = document.querySelector(".cart-drawer__step-four");
  const field = document.getElementById("datepicker");

  if (!field) {
    return;
  }

  const deliveryDates = Array.from(productCartItems).map((element) =>
    moment(element.getAttribute("earliest_delivery_date"), "YYYY-M-D").toDate()
  );
  const latestDeliveryDate = deliveryDates.reduce(
    (latest, current) => (current > latest ? current : latest),
    new Date()
  );

  const tomorrow = moment().add(1, "days").startOf("day");
  const threeMonthsFromNowDate = moment()
    .add(3, "months")
    .startOf("day")
    .toDate();

  const minDate =
    latestDeliveryDate > tomorrow.toDate()
      ? latestDeliveryDate
      : tomorrow.toDate();

  const disabledDatesAttribute = document.body.getAttribute(
    "data-disabled-dates"
  );
  const disabledDates = disabledDatesAttribute
    ? disabledDatesAttribute.split(",").map((date) => date.trim())
    : [];

  const currentValue = field.value;

  pickerInstance = new Pikaday({
    minDate: minDate,
    maxDate: threeMonthsFromNowDate,
    format: "DD/MM/YYYY",
    disableDayFn: function (date) {
      const formattedDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const isWeekendTomorrow =
        tomorrow.getDay() === 0 || tomorrow.getDay() === 6;
      let cutoffHour = isWeekendTomorrow ? 12 : 13;

      // Never allow delivery on Sundays (standard and morning delivery methods)
      if(date.getDay() === 0) {
        return true;
      }

      // for Morning Delivery, we disable Saturday and Sunday
      if(isMorningDelivery && date.getDay() === 6) {
        return true;
      }
 
      const isWeekendToday = today.getDay() === 0 || today.getDay() === 6;
      if (isWeekendToday) {
        cutoffHour = 12;
      }

      const isBeforeCutoff = moment().hour() < cutoffHour;
      return (
        disabledDates.includes(formattedDate) ||
        (date.getDate() === tomorrow.getDate() &&
          date.getMonth() === tomorrow.getMonth() &&
          date.getFullYear() === tomorrow.getFullYear() &&
          !isBeforeCutoff)
      );
    },
    onSelect: function (date) {
      const selectedDate = pickerInstance.toString();
      console.log(selectedDate);
      field.value = "";
      field.value = currentValue + selectedDate;
      stepThree.classList.remove("step-three-active");
      stepFour.classList.add("step-four-active");
      const stepFourTitle = document.querySelector(".four-step-date");
      stepFourTitle.textContent = pickerInstance.toString();
    },
  });

  field.parentNode.insertBefore(pickerInstance.el, field.nextSibling);
}

document.addEventListener("DOMContentLoaded", function () {
  initializePikaday();
});

document.addEventListener("line-item:change:end", function (evt) {
  initializePikaday();
});

const elements = document.querySelectorAll(
  ".press-swiper__next, .press-swiper__prev"
);

elements.forEach((element) => {
  const cursor = element.querySelector(".customCursor");
  element.addEventListener("mousemove", function (e) {
    const rect = element.getBoundingClientRect();
    cursor.style.left = e.clientX - rect.left - cursor.offsetWidth / 2 + "px";
    cursor.style.top = e.clientY - rect.top - cursor.offsetHeight / 2 + "px";
    cursor.style.opacity = "1";
  });

  element.addEventListener("mouseleave", () => {
    cursor.style.opacity = "0";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const inputForStorage = document.querySelector(".cart-drawer__post-code");
  const deliveryPostCode1 = document.querySelector(
    ".cart-drawer__postcode-value"
  );
  const deliveryPostCode2 = document.querySelector(
    ".delivery-postcode-step-three"
  );
  const deliveryPostCode3 = document.querySelector(".four-step-code");

  if (inputForStorage) {
    const storedPostCode = localStorage.getItem("postCode");

    if (storedPostCode) {
      inputForStorage.value = storedPostCode;

      if (deliveryPostCode1) {
        deliveryPostCode1.innerHTML = storedPostCode;
      }
      if (deliveryPostCode2) {
        deliveryPostCode2.innerHTML = storedPostCode;
      }
      if (deliveryPostCode3) {
        deliveryPostCode3.innerHTML = storedPostCode;
      }
    }
  }
});
document.addEventListener("line-item:change:end", function (evt) {
  const inputForStorage = document.querySelector(".cart-drawer__post-code");
  const deliveryPostCode1 = document.querySelector(
    ".cart-drawer__postcode-value"
  );
  const deliveryPostCode2 = document.querySelector(
    ".delivery-postcode-step-three"
  );
  const deliveryPostCode3 = document.querySelector(".four-step-code");

  if (inputForStorage) {
    const storedPostCode = localStorage.getItem("postCode");

    if (storedPostCode) {
      inputForStorage.value = storedPostCode;

      if (deliveryPostCode1) {
        deliveryPostCode1.innerHTML = storedPostCode;
      }
      if (deliveryPostCode2) {
        deliveryPostCode2.innerHTML = storedPostCode;
      }
      if (deliveryPostCode3) {
        deliveryPostCode3.innerHTML = storedPostCode;
      }
    }
  }
});

document.addEventListener("buildCartRemove", function (e) {
  const inputForStorage = document.querySelector(".cart-drawer__post-code");
  const deliveryPostCode1 = document.querySelector(
    ".cart-drawer__postcode-value"
  );
  const deliveryPostCode2 = document.querySelector(
    ".delivery-postcode-step-three"
  );
  const deliveryPostCode3 = document.querySelector(".four-step-code");

  if (inputForStorage) {
    const storedPostCode = localStorage.getItem("postCode");

    if (storedPostCode) {
      inputForStorage.value = storedPostCode;

      if (deliveryPostCode1) {
        deliveryPostCode1.innerHTML = storedPostCode;
      }
      if (deliveryPostCode2) {
        deliveryPostCode2.innerHTML = storedPostCode;
      }
      if (deliveryPostCode3) {
        deliveryPostCode3.innerHTML = storedPostCode;
      }
    }
  }
});

let loader = document.querySelector(".loader-cart");

document.body.addEventListener("change", function (event) {
  if (event.target.matches('[name="selling-plan-build"]')) {
    let selectedIndex = event.target.selectedIndex;
    document
      .querySelectorAll('[name="selling-plan-build"]')
      .forEach(function (element) {
        element.selectedIndex = selectedIndex;
      });

    let loader = document.querySelector(".loader-cart");
    loader.classList.add("active");

    updateProductsWithDelay(
      Array.from(document.querySelectorAll('[name="selling-plan-build"]')),
      100
    )
      .then(() => {
        loader.classList.remove("active");
      })
      .catch((error) => {
        console.error("Failed to update products:", error);
        loader.classList.remove("active");
      });
  }
});

document.body.addEventListener("change", function (event) {
  if (event.target.matches('[name="selling-plan"]')) {
    let data = {
      line: event.target.dataset.line,
      quantity: event.target.dataset.quantity,
      id: event.target.dataset.variant,
      selling_plan: event.target.value,
    };

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Successfully updated:", data);
          updateCartSections();
        } else {
          console.error("Server responded with status:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});

const cartDrawer = new CartDrawer();

function updateCartSections() {
  cartDrawer.updateCartContents();
}

function updateCartPlanPage() {
  cartDrawer.updateCartPlanPage();
}

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("find-plan__form");

  const limitedProductIds = [
    40856827658282, 40862532861994, 40862532567082, 40856867831850,
  ];

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {

          const existingVariantIds = cart.items.map((item) => item.variant_id);
          const formDataForSubmission = new FormData();
          let addItem = true;

          for (const [key, value] of new FormData(form)) {
            if (key === "items[][id]") {
              const productId = parseInt(value);
              addItem = limitedProductIds.includes(productId)
                ? !existingVariantIds.includes(productId)
                : true;
            }
            if (addItem) formDataForSubmission.append(key, value);
          }

          if (formDataForSubmission.has("items[][id]")) {
            return fetch("/cart/add", {
              method: "POST",
              body: formDataForSubmission,
            });
          }
        })
        .then((response) => {
          if (response && response.ok) {
            const itemAddedEvent = new CustomEvent("itemAddedToCart", {
              detail: {
                message: "Product successfully added to cart.",
              },
            });
            document.dispatchEvent(itemAddedEvent);
            updateCartPlanPage();
          } else {
            console.error("error", response.status);
          }
        })
        .catch((error) => {
          console.error("error:", error);
        });
    });
  }
});

async function removeAllProductsFromList(productIds) {
  
  if(!productIds || productIds.length === 0) {
    return;
  }

  let endpoint = `/cart/change.js`;

  const cartLoader = document.querySelector(".loader-cart");
  if (cartLoader) {
    cartLoader.classList.add("active");
  }

  for (let productId of productIds) {
    let formData = new FormData();
    formData.append("id", productId);
    formData.append("quantity", 0);

    try {
      let response = await fetch(endpoint, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      let jsonResponse = await response.json();
      console.log("Product removed successfully!", jsonResponse);
    } catch (error) {
      console.error("Error removing product from cart:", error);
      break;
    }
  }

  updateCartPlanPage();

  if (cartLoader) {
    cartLoader.classList.remove("active");
  }
}

function getProductIdsFromCart() {
  const productElements = document.querySelectorAll("[product-cart-id]");
  return Array.from(productElements).map((el) =>
    el.getAttribute("product-cart-id")
  );
}


async function updateProductsWithDelay(elements, delay) {
  try {
    for (let element of elements) {
      let data = {
        line: element.dataset.line,
        quantity: element.dataset.quantity,
        id: element.dataset.variant,
        selling_plan: element.value,
      };

      let response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }
    }

    console.log("All products updated");
    await updateCartSections();
  } catch (error) {
    console.error("Failed to update product:", data, error);
  }
}

function getTimeMessage() {
  const now = moment.tz("Europe/London");

  const dayOfWeek = now.day();
  const hourOfDay = now.hour();

  const startTime = now.clone().hour(6).minute(0).second(0);
  const targetTime = now.clone().hour(13).minute(0).second(0);

  if(dayOfWeek !== 6) { // never show anything on Saturdays (as we don't offer delivery on Sundays any more)
    if ((dayOfWeek === 0 && hoursOfDay >= 6 && hourOfDay < 11) || // Sundays, next day delivery is available for orders before 11am
    (dayOfWeek !== 6 && now.isAfter(startTime) && now.isBefore(targetTime))) { // Other days of the week, next day delivery is available for orders before 1pm
      const diffHrs = targetTime.diff(now, "hours");
      const diffMins = targetTime
        .clone()
        .subtract(diffHrs, "hours")
        .diff(now, "minutes");
  
      return `<p class="product-description__delivery-info__message">Order within
      <b>${diffHrs}hr ${diffMins}mins</b>
      for delivery tomorrow<br>or Choose delivery date at checkout</p>`;
    }
  }
  
  
  return "<p class='product-description__delivery-info__message'>Choose your delivery date at checkout</p>";
  
}

const message = getTimeMessage();

const buildMessageElement = document.querySelector(".build-message");
const deliveryMessageElement = document.querySelector(".delivery-message");

if (buildMessageElement) {
  buildMessageElement.innerHTML = message;
}

if (deliveryMessageElement) {
  deliveryMessageElement.innerHTML = message;
}

document.addEventListener("DOMContentLoaded", () => {
  const badges = document.querySelectorAll(".best-seller__latest p");

  if (badges.length === 0) return;

  const speed = 20;

  badges.forEach((badge) => {
    const totalDistance = badge.offsetWidth;
    const duration = totalDistance / speed;
    badge.style.animationDuration = `${duration}s`;
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const badges = document.querySelectorAll(".home-articles__latest p");

  if (badges.length === 0) return;

  const speed = 20;

  badges.forEach((badge) => {
    const totalDistance = badge.offsetWidth;
    const duration = totalDistance / speed;
    badge.style.animationDuration = `${duration}s`;
  });
});

AOS.init({ once: true });

document.addEventListener("quick-view:open", function (evt) {
  window.loyaltylion && window.loyaltylion.ui.refresh();

  const productIdElement = document.querySelector('input[name="product-id"]');
  if (productIdElement) {
    let productId = productIdElement.getAttribute("value");
    productId = parseInt(productId, 10);
    if (productId) {
      window.ReChargeWidget.createWidget({
        productId: productId,
        selectors: {
          price: [".thb-product-detail .price"],
          variant: [".variant-selector", ".variant-button"],
        },
      });
    }
  }
});

document.addEventListener('cart:item-added', function (evt) {

  console.log('Sending Added to Cart Klaviyo Event');

  // Added to Cart Klaviyo Event
  // var _learnq = _learnq || []; // this line breaks it, not sure why

  var productPrice = parseInt(evt.detail.product.price, 10) / 100;
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: window.theme.settings.cart_currency_iso_code,
    maximumFractionDigits: 2
  });

  productPrice = formatter.format(productPrice);


  var item = {
    ProductID: evt.detail.product.id,
    Quantity: evt.detail.product.quantity,
    Price: productPrice,
    URL: theme.routes.shop_url + evt.detail.product.url,
    ImageUrl: evt.detail.product.image,
    SecondaryImageUrl: evt.detail.product.featured_image,
    Name: evt.detail.product.title,
    Sku: evt.detail.product.sku,
    CartUrl: theme.routes.shop_url + theme.routes.cart_url,
  };
  _learnq.push(['track', 'Added to Cart', item]);

});

document.addEventListener("product:variant-change", function (evt) {
  window.loyaltylion && window.loyaltylion.ui.refresh();
});

document.addEventListener("line-item:change:end", function (evt, cart) {
  checkCartDoesNotContainFreeGiftsThatRequireOtherItemsInTheCart();
});

document.addEventListener("cart-drawer:open", function () {
  checkCartDoesNotContainFreeGiftsThatRequireOtherItemsInTheCart();
});

// This tries to remove free gifts / booster products that require other products in the cart in order to be valid
async function checkCartDoesNotContainFreeGiftsThatRequireOtherItemsInTheCart() {
  const elements = document.querySelectorAll('[data-requires-other-products]');
  const cartLineItemIdsToRemoveFromCart = [];
  for (const element of elements) {
    const value = element.getAttribute('data-requires-other-products');
    const values = value.split(',');
    
    const requiredProductExists = values.some(function(value) {
      return document.querySelector('[cart-item-product-id="' + value + '"]') !== null;
    });

    if(!requiredProductExists) {
      cartLineItemIdsToRemoveFromCart.push(element.getAttribute('product-cart-id'));
      // Remove one at a time otherwise it doesn't work properly
    }
  };
  await removeAllProductsFromList(cartLineItemIdsToRemoveFromCart);
}

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("keydown", function (event) {
    if (event.target && event.target.matches(".qty")) {
      event.preventDefault();
    }
  });

  document.body.addEventListener('click', function(event) {
    const anchor = event.target.closest('a');
    if (anchor) {
      const urlParams = new URLSearchParams(new URL(anchor.href).search);
      if (urlParams.has('scrollToSection')) {
        const sectionIndex = parseInt(urlParams.get('scrollToSection'));
        
        const sections =  document.querySelector("#main-content").querySelectorAll('.shopify-section');
        if (sectionIndex && sectionIndex < sections.length) {
          
          jQuery('html, body').animate({
            scrollTop: $(sections[sectionIndex]).offset().top - 69 // 69 is the height of the sticky header
          });

          event.preventDefault();
          event.stopPropagation();
        }
      }
    }
  });


});
